import React from "react";
import {Upload} from "antd";
import {InboxOutlined} from "@ant-design/icons";

const SingleFileUploader = ({
                                fileList = [],
                                onUpload,
                                onChange,
                                onRemove,
                                label,
                                accept = ".pdf,image/*",
                                showUploadList = false,
                            }) => {
    return (
        <div className="single-file-uploader w-full">
            {label && (
                <label className="block text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">
                    {label}
                </label>
            )}
            <Upload
                accept={accept}
                fileList={fileList}
                customRequest={onUpload}
                onChange={({file}) => onChange?.(file)}
                onRemove={onRemove}
                showUploadList={showUploadList}
            >
                <div
                    className="w-full flex items-center justify-center gap-2"
                    style={{
                        border: "1.5px dashed #CFD4DF",
                        borderRadius: 10,
                        padding: "18px",
                        textAlign: "center",
                        color: "#7A849A",
                        fontSize: 13,
                        cursor: "pointer",
                        background: "#FAFBFE",
                    }}
                >
                    {fileList.length > 0 ? (
                        <span className="text-[#0B1220] font-medium truncate">{fileList[0].name}</span>
                    ) : (
                        <>
                            <InboxOutlined style={{fontSize: 22, color: "#7A849A"}}/>
                            <span>Drag &amp; drop a file here, or click to browse</span>
                        </>
                    )}
                </div>
            </Upload>
            <style>{`
                .single-file-uploader .ant-upload-wrapper,
                .single-file-uploader .ant-upload-wrapper .ant-upload,
                .single-file-uploader .ant-upload-wrapper .ant-upload-select {
                    display: block;
                    width: 100%;
                }
            `}</style>
        </div>
    );
};

export default SingleFileUploader;
